import { COLORS } from "./colors";

export function createLogger(namespace: string) {
  const formattedNamespace = namespace.trim().toUpperCase();

  // Because we have no logger implementation yet, we use the console as a placeholder
  /* eslint-disable no-console */
  return {
    debug: (...arguments_: Parameters<typeof console.debug>) =>
      console.debug(
        `${COLORS.debug}🐛 [${formattedNamespace}]${COLORS.reset}`,
        ...arguments_,
      ),
    log: (...arguments_: Parameters<typeof console.log>) =>
      console.log(
        `${COLORS.log}📄 [${formattedNamespace}]${COLORS.reset}`,
        ...arguments_,
      ),
    info: (...arguments_: Parameters<typeof console.info>) =>
      console.info(
        `${COLORS.info}️ℹ️ [${formattedNamespace}]${COLORS.reset}`,
        ...arguments_,
      ),
    warn: (...arguments_: Parameters<typeof console.warn>) =>
      console.warn(
        `${COLORS.warn}⚠ [${formattedNamespace}]${COLORS.reset}`,
        ...arguments_,
      ),
    error: (...arguments_: Parameters<typeof console.error>) =>
      console.error(
        `${COLORS.error}❌ [${formattedNamespace}]${COLORS.reset}`,
        ...arguments_,
      ),
  };
  /* eslint-enable no-console */
}
